(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["dynamic-slideshow-logos-2"] && !window.DesignMode) return;
  try {
    
  $(sectionBrandsId2).owlCarousel({
    loop:true,
    margin:10,
    responsiveClass:true,
    responsive:{
        0:{
            items:1,
            nav:true
        },
        720:{
            items:3,
            nav:true
        },
        1000:{
            items:4,
            nav:true
        }
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-slideshow-logos"] && !window.DesignMode) return;
  try {
    
  $(sectionBrandsId).owlCarousel({
    loop:true,
    margin:10,
    responsiveClass:true,
    responsive:{
        0:{
            items:1,
            nav:true
        },
        720:{
            items:3,
            nav:true
        },
        1000:{
            items:4,
            nav:true
        }
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-slideshow-products-2"] && !window.DesignMode) return;
  try {
    
$(slideshowProducts2).owlCarousel({
    loop:true,
    dots:false,
    responsive:{
        0:{
            items:1,
            nav:true
        },
        720:{
            items:2,
            nav:true
        },
        1000:{
            items:3,
            nav:true
        }
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-slideshow-products-3"] && !window.DesignMode) return;
  try {
    
$(slideshowProducts3).owlCarousel({
    loop:true,
    dots:false,
    responsive:{
        0:{
            items:1,
            nav:true
        },
        720:{
            items:2,
            nav:true
        },
        1000:{
            items:3,
            nav:true
        }
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-slideshow-products-4"] && !window.DesignMode) return;
  try {
    
$(slideshowProducts4).owlCarousel({
    loop:true,
    dots:false,
    responsive:{
        0:{
            items:1,
            nav:true
        },
        720:{
            items:2,
            nav:true
        },
        1000:{
            items:3,
            nav:true
        }
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-slideshow-products-5"] && !window.DesignMode) return;
  try {
    
$(slideshowProducts5).owlCarousel({
    loop:true,
    dots:false,
    responsive:{
        0:{
            items:1,
            nav:true
        },
        720:{
            items:2,
            nav:true
        },
        1000:{
            items:3,
            nav:true
        }
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-slideshow-products"] && !window.DesignMode) return;
  try {
    
$(testval).owlCarousel({
    loop:true,
    dots:false,
    responsive:{
        0:{
            items:1,
            nav:true
        },
        720:{
            items:2,
            nav:true
        },
        1000:{
            items:3,
            nav:true
        }
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-product-recommendations"]) return;
  try {
    
  setTimeout(()=>{
	$(productRecommendationsCarousel).owlCarousel({
  	loop:true,
  	dots:false,
    margin:10,
    responsiveClass:true,
    responsive:{
        0:{
            items:1,
            nav:true
        },
        720:{
            items:2,
            nav:true
        },
        1000:{
            items:3,
            nav:true
        }
    }
	});
  },2000);

  } catch(e) { console.error(e); }
})();

})();
